import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getServiceTypeAvailableColumns } from './api';

export const path = '/service-type/list';

const PageServiceTypeList: React.FC = (props) => {
  const ServiceType = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getServiceTypeAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <ServiceType {...props} />;
};

export default PageServiceTypeList;
